import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';
import styled from 'styled-components';
import clss from 'classnames';
import { getTargetAddressByTxnDetail } from '@/constants/Transaction';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { gettext } from '@/utils/langsBook';
import { makeShardDetailLink, makeTxDetailLink } from '@/utils/link';
import getTxService from '@/api/transactions';
import Icon from '@/components/base/Icon';
import Tooltip from '@/components/base/Tooltip';
import Toast from '@/components/base/Toast';
import Link from '@/components/base/Linker';
import { toShard } from '@/utils/string';
import { observer } from 'mobx-react-lite';
import txnTreeStore from '@/store/TxnTree';
import refreshStore from '@/store/Refresh';
import AddressLink from '../AddressLink';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FULL_NAME = 'full';
var ZOOM_NAME = 'zoom';
var TransactionTreeStyled = styled.div.withConfig({
    displayName: "TransactionTree__TransactionTreeStyled",
    componentId: "sc-wrqvfq-0"
})([
    "",
    " &.full{@extend container-min-w;",
    "}.scale{",
    "}.ex-tree{",
    " &-item{",
    " &:not(:last-child){",
    "}.target-bg{",
    "}}&-group{",
    " .ex-tree-y-liner{",
    "}}&-switcher{",
    " &-close{",
    " &::after{content:'+';}}&-open{",
    " &::after{content:'-';}}}&-indent-unit{display:inline-block;width:27px;}&-y-liner{",
    "}&-x-liner{",
    " &::after{",
    "}}}"
], {
    "backgroundColor": "var(--color-box-bg)",
    "paddingTop": "96px",
    "paddingLeft": "120px",
    "borderRadius": "8px",
    "position": "relative",
    "transitionProperty": "all",
    "transitionTimingFunction": "cubic-bezier(0.4, 0, 0.2, 1)",
    "transitionDuration": "300ms",
    "transformOrigin": "bottom right"
}, {
    "display": "inline-block",
    "width": "100vw",
    "height": "100vh",
    "zIndex": "999",
    "margin": "0",
    "overflowY": "hidden"
}, {
    "position": "absolute",
    "top": "24px",
    "right": "24px",
    "cursor": "pointer",
    "zIndex": "50"
}, {
    "position": "relative",
    "height": "100%",
    "paddingTop": "10px"
}, {
    "fontSize": "14px",
    "lineHeight": "17px",
    "position": "relative"
}, {
    "marginBottom": "12px"
}, {
    "width": "900px",
    "height": "44px",
    "backgroundColor": "var(--color-bg)",
    "position": "absolute",
    "top": "-10px",
    "left": "-10px",
    "borderRadius": "4px"
}, {
    "paddingTop": "12px",
    "paddingBottom": "12px",
    "position": "relative",
    "marginTop": "6px",
    "paddingRight": "27px",
    "borderRadius": "4px",
    "minWidth": "1000px",
    "paddingLeft": "12px"
}, {
    "top": "-18px",
    "height": "26px"
}, {
    "marginRight": "13.5px",
    "borderRadius": "9999px",
    "width": "14px",
    "height": "14px",
    "fontSize": "12px",
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "cursor": "pointer",
    "pointerEvents": "none",
    "zIndex": "50"
}, {
    "borderWidth": "1px",
    "borderColor": "var(--color-border)",
    "backgroundColor": "var(--color-box-bg)",
    "color": "var(--color-desc-text)",
    "pointerEvents": "auto"
}, {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(107, 114, 128, var(--tw-bg-opacity))",
    "color": "var(--color-text-other)",
    "pointerEvents": "auto"
}, {
    "width": "1px",
    "height": "22px",
    "position": "absolute",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgba(204, 204, 204, var(--tw-bg-opacity))",
    "top": "-14px",
    "zIndex": "1",
    "left": "-32px"
}, {
    "position": "absolute",
    "top": "12px",
    "height": "0px",
    "width": "27px",
    "right": "calc(100% + 3px)",
    "display": "flex",
    "alignItems": "center"
}, {
    "content": "''",
    "width": "5px",
    "height": "5px",
    "left": "-3.5px",
    "backgroundColor": "var(--color-text-primary)",
    "borderRadius": "9999px",
    "position": "absolute",
    "top": "-2.5px",
    "zIndex": "50",
    "overflow": "hidden"
});
var tx = getTxService(); // Tx.Detail to tree node
var filterSource = function(data) {
    var ref;
    return {
        Function: data === null || data === void 0 ? void 0 : data.Function,
        Input: JSON.stringify(data === null || data === void 0 ? void 0 : data.Input),
        Hash: data === null || data === void 0 ? void 0 : data.Hash,
        OrigTxHash: data === null || data === void 0 ? void 0 : data.OrigTxHash,
        Relays: data === null || data === void 0 ? void 0 : (ref = data.Invocation) === null || ref === void 0 ? void 0 : ref.Relays,
        Children: undefined,
        OriginDetail: data
    };
}; // root
var TransactionTree = function(props) {
    var ref7 = props || {}, className = ref7.className, data = ref7.data;
    var ref1 = useState(''), scale = ref1[0], setScale = ref1[1];
    var ref2 = useState(), originData = ref2[0], setOriginData = ref2[1];
    var ref3 = useState([]), selected = ref3[0], setSelected = ref3[1];
    var ref4 = useState(false), loading = ref4[0], setLoading = ref4[1];
    var treeRef = useRef(null);
    var Router = useRouter();
    var cacheTree = txnTreeStore.cache;
    var refresh = refreshStore.refresh;
    useEffect(function() {
        if (refresh && data) {
            setSelected([]);
            resetScale();
            setScale('');
            txnTreeStore.clearTxnCache();
            var newOriginData = filterSource(data);
            setOriginData(newOriginData);
        }
    }, [
        refresh,
        data
    ]);
    useEffect(function() {
        window.addEventListener('resize', fullTree);
        return function() {
            window.removeEventListener('resize', fullTree);
            resetScale();
        };
    }, []);
    useEffect(function() {
        setSelected([]);
        resetScale();
        setScale('');
        if (cacheTree.selected) {
            setSelected(cacheTree.selected);
        }
        if (cacheTree.source) {
            setOriginData(cacheTree.source);
        }
    }, [
        Router
    ]);
    useEffect(function() {
        if (data && !cacheTree.source) {
            var newOriginData = filterSource(data);
            setOriginData(newOriginData); // has cache but target not in
        } else if (data && !findTargetBFS(cacheTree.source, data === null || data === void 0 ? void 0 : data.Hash)) {
            txnTreeStore.clearTxnCache();
            var newOriginData1 = filterSource(data);
            setOriginData(newOriginData1);
        }
    }, [
        data,
        cacheTree
    ]);
    var findTargetBFS = useCallback(function(targetTree, target) {
        if (!target) return null;
        if (!targetTree) return null;
        var q = [
            targetTree
        ];
        while(q.length){
            var item = q.shift();
            if (item === null || item === void 0 ? void 0 : item.Children) {
                item.Children.forEach(function(t) {
                    return q.push(t);
                });
            }
            if ((item === null || item === void 0 ? void 0 : item.Hash) === target) return item;
        }
        return null;
    }, []);
    var resetScale = useCallback(function() {
        treeRef.current && treeRef.current.setAttribute('style', '');
        document.body.style.overflow = 'auto';
    }, [
        treeRef
    ]);
    var fullTree = useCallback(function() {
        var ref;
        if (treeRef.current && ((ref = treeRef.current) === null || ref === void 0 ? void 0 : ref.classList.contains(FULL_NAME))) {
            var ref5 = new WebKitCSSMatrix(treeRef.current.style.transform), translateX = ref5.m41, translateY = ref5.m42;
            var ref6 = treeRef.current.getBoundingClientRect() || {}, _top = ref6.top, top = _top === void 0 ? 0 : _top, _left = ref6.left, left = _left === void 0 ? 0 : _left;
            treeRef.current.style.transform = "translate(".concat(Math.floor(translateX - left), "px, ").concat(translateY - top, "px)");
        }
    }, [
        treeRef
    ]);
    var handleScale = useCallback(function() {
        var newScale = scale === FULL_NAME ? ZOOM_NAME : FULL_NAME;
        setScale(newScale);
        if (newScale === FULL_NAME && treeRef.current) {
            if (treeRef.current) {
                var ref = treeRef.current.getBoundingClientRect() || {}, _top = ref.top, top = _top === void 0 ? 0 : _top, _left = ref.left, left = _left === void 0 ? 0 : _left;
                var gap = document.body.scrollWidth - window.innerWidth;
                if (gap) {
                    treeRef.current.width = window.innerWidth;
                }
                treeRef.current.style.transform = "translate(".concat(left * -1, "px, ").concat(top * -1, "px)");
                document.body.style.overflow = 'hidden';
            }
        } else {
            resetScale();
        }
    }, [
        scale
    ]);
    var handleParent = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        var detail, ref, newOriginData, childRelay, i, relayHash, childDetail;
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (!(originData === null || originData === void 0 ? void 0 : originData.OrigTxHash)) {
                        _ctx.next = 37;
                        break;
                    }
                    setLoading(true);
                    handleSelected(originData === null || originData === void 0 ? void 0 : originData.OrigTxHash);
                    _ctx.prev = 3;
                    _ctx.next = 6;
                    return tx.getTxDetail(originData === null || originData === void 0 ? void 0 : originData.OrigTxHash);
                case 6:
                    detail = _ctx.sent;
                    if (!detail) {
                        _ctx.next = 30;
                        break;
                    }
                    ;
                    newOriginData = filterSource(detail);
                    childRelay = ((ref = newOriginData.Relays) === null || ref === void 0 ? void 0 : ref.filter(function(r) {
                        return r !== (originData === null || originData === void 0 ? void 0 : originData.Hash);
                    })) || [];
                    newOriginData.Relays = [
                        originData === null || originData === void 0 ? void 0 : originData.Hash
                    ].concat(_toConsumableArray(childRelay));
                    newOriginData.Children = [
                        originData
                    ]; // loop child relays
                    if (!(childRelay === null || childRelay === void 0 ? void 0 : childRelay.length)) {
                        _ctx.next = 28;
                        break;
                    }
                    i = 0;
                case 15:
                    if (!(i < childRelay.length)) {
                        _ctx.next = 28;
                        break;
                    }
                    relayHash = childRelay[i];
                    if (!(relayHash === (originData === null || originData === void 0 ? void 0 : originData.Hash))) {
                        _ctx.next = 21;
                        break;
                    }
                    {
                        newOriginData.Children.push(originData);
                    }
                    _ctx.next = 25;
                    break;
                case 21:
                    _ctx.next = 23;
                    return tx.getTxDetail(relayHash);
                case 23:
                    childDetail = _ctx.sent;
                    childDetail && newOriginData.Children.push(filterSource(childDetail));
                case 25:
                    i++;
                    _ctx.next = 15;
                    break;
                case 28:
                    setOriginData(newOriginData);
                    txnTreeStore.setTxnCacheSource(newOriginData);
                case 30:
                    setLoading(false);
                    _ctx.next = 37;
                    break;
                case 33:
                    _ctx.prev = 33;
                    _ctx.t0 = _ctx["catch"](3);
                    setLoading(false);
                    Toast.error(_ctx.t0);
                case 37:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                3,
                33
            ]
        ]);
    })), [
        originData,
        selected
    ]);
    var handleSelected = useCallback(function(key) {
        var selectIndex = selected.findIndex(function(s) {
            return s === key;
        });
        var newSelected = selected;
        if (~selectIndex) {
            newSelected.splice(selectIndex, 1);
        } else {
            newSelected = _toConsumableArray(newSelected).concat([
                key
            ]);
        }
        setSelected(newSelected);
        txnTreeStore.setTxnCacheSelected(newSelected);
        txnTreeStore.setTxnCacheSource(originData);
    }, [
        selected,
        originData
    ]);
    var scaleIcon = useMemo(function() {
        return scale === FULL_NAME ? 'scale-down' : 'scale-up';
    }, [
        scale
    ]);
    return(/*#__PURE__*/ _jsxs(TransactionTreeStyled, {
        ref: treeRef,
        className: clss(scale, className),
        children: [
            /*#__PURE__*/ _jsx(Icon, {
                type: scaleIcon,
                className: "text-[48px] scale transition-transform hover:scale-[1.2] hover:font-bold",
                onClick: handleScale
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "ex-tree overflow-auto",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-[10px] left-0",
                        children: loading ? /*#__PURE__*/ _jsx(Icon, {
                            className: "mr-[12px] z-[2] animate-spin",
                            type: "refresh"
                        }) : (originData === null || originData === void 0 ? void 0 : originData.OrigTxHash) ? /*#__PURE__*/ _jsx(Icon, {
                            className: "mr-[12px] z-[2] text-[24px]",
                            type: "fold",
                            onClick: handleParent
                        }) : /*#__PURE__*/ _jsx(Icon, {
                            className: "mr-[12px] z-[2] text-[24px] opacity-30",
                            type: "unfold"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ml-[27px] pl-[12px] relative",
                        children: /*#__PURE__*/ _jsx(RelayItem, {
                            showLine: false,
                            source: originData,
                            onTrrigerChild: handleSelected,
                            selected: selected,
                            isScale: scale === FULL_NAME
                        })
                    })
                ]
            })
        ]
    }));
}; // sub node
var RelayItem = function(param) {
    var source = param.source, _showLine = param.showLine, showLine = _showLine === void 0 ? true : _showLine, onTrrigerChild = param.onTrrigerChild, selected = param.selected, _isScale = param.isScale, isScale = _isScale === void 0 ? false : _isScale;
    var ref15, ref8, ref9, ref10, ref11;
    var ref12 = useState(''), childStatus = ref12[0], setChildStatus = ref12[1];
    var ref13 = useState(false), loading = ref13[0], setLoading = ref13[1];
    var ref14 = useState(''), targetAddress = ref14[0], setTargetAddress = ref14[1];
    var router = useRouter();
    var targetHash = (ref15 = router.query) === null || ref15 === void 0 ? void 0 : ref15.hash;
    useEffect(function() {
        if (source === null || source === void 0 ? void 0 : source.OriginDetail) {
            getTargetAddressByTxnDetail(source === null || source === void 0 ? void 0 : source.OriginDetail).then(setTargetAddress);
        }
    }, [
        source
    ]);
    useEffect(function() {
        var ref;
        var hasChild = !!(source === null || source === void 0 ? void 0 : (ref = source.Relays) === null || ref === void 0 ? void 0 : ref.length); // init tree
        if (hasChild) {
            var initStatus = selected.includes((source === null || source === void 0 ? void 0 : source.Hash) || '');
            setChildStatus(initStatus ? 'open' : 'close');
        } else {
            setChildStatus('');
        }
    }, [
        source,
        selected
    ]);
    var renderIcon = useMemo(function() {
        if (loading) return(/*#__PURE__*/ _jsx(Icon, {
            type: "refresh",
            className: "animate-spin mr-[12px] z-[2]"
        })); // request
        var handleChildStatus = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var newChildren, newStatus;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (childStatus) {
                                _ctx.next = 2;
                                break;
                            }
                            return _ctx.abrupt("return");
                        case 2:
                            if (!(source && !(source === null || source === void 0 ? void 0 : source.Children))) {
                                _ctx.next = 16;
                                break;
                            }
                            setLoading(true);
                            _ctx.prev = 4;
                            _ctx.next = 7;
                            return Promise.all(((source === null || source === void 0 ? void 0 : source.Relays) || []).map(function(d) {
                                return tx.getTxDetail(d);
                            })).then(function(res) {
                                var filterArr = [];
                                res.forEach(function(r) {
                                    r && filterArr.push(filterSource(r));
                                });
                                return filterArr;
                            });
                        case 7:
                            newChildren = _ctx.sent;
                            source.Children = newChildren.length ? newChildren : undefined;
                            txnTreeStore.setTxnCacheSource(source);
                            _ctx.next = 15;
                            break;
                        case 12:
                            _ctx.prev = 12;
                            _ctx.t0 = _ctx["catch"](4);
                            console.log(_ctx.t0);
                        case 15:
                            setLoading(false);
                        case 16:
                            if (source === null || source === void 0 ? void 0 : source.Children) {
                                newStatus = childStatus !== 'open' ? 'open' : 'close';
                                setChildStatus(newStatus);
                                onTrrigerChild && source && onTrrigerChild(source.Hash);
                            }
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        12
                    ]
                ]);
            }));
            return function handleChildStatus() {
                return _ref.apply(this, arguments);
            };
        }();
        var iconType = !childStatus ? 'expand-empty' : childStatus === 'close' ? 'expand' : 'unexpand';
        return(/*#__PURE__*/ _jsx(Icon, {
            className: "mr-[12px] z-[2]",
            type: iconType,
            onClick: handleChildStatus
        }));
    }, [
        childStatus,
        source,
        onTrrigerChild,
        loading
    ]);
    var renderContract = useMemo(function() {
        if (!(source === null || source === void 0 ? void 0 : source.Input)) return '';
        var DynamicReactJson = dynamic(import('react-json-view'), {
            loadableGenerated: {
                webpack: function() {
                    return [
                        require.resolveWeak("react-json-view")
                    ];
                }
            },
            ssr: false
        });
        return(/*#__PURE__*/ _jsx("div", {
            className: "min-w-[500px] max-w-[884px] overflow-x-auto overflow-y-auto max-h-[600px]",
            children: /*#__PURE__*/ _jsx(DynamicReactJson, {
                src: JSON.parse(source === null || source === void 0 ? void 0 : source.Input),
                displayObjectSize: false,
                enableClipboard: false,
                displayDataTypes: false,
                name: false
            })
        }));
    }, [
        source
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        className: "ex-tree-item",
        children: [
            targetHash === (source === null || source === void 0 ? void 0 : source.Hash) && /*#__PURE__*/ _jsx("div", {
                className: "target-bg"
            }),
            source && source.OriginDetail && /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center text-[16px] relative z-10",
                children: [
                    renderIcon,
                    showLine && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "ex-tree-y-liner"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "ex-tree-x-liner",
                                children: /*#__PURE__*/ _jsx(Icon, {
                                    type: "long-arrow",
                                    className: "text-[16px] text-desc"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-[5px]",
                        children: gettext('Hash')
                    }),
                    source && /*#__PURE__*/ _jsxs("div", {
                        className: "mr-[40px]",
                        children: [
                            /*#__PURE__*/ _jsx(Link, {
                                href: makeTxDetailLink(source === null || source === void 0 ? void 0 : source.Hash),
                                text: source.Hash,
                                isHash: true
                            }),
                            !!Number((ref8 = source.OriginDetail) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.Invocation) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.Return) === null || ref10 === void 0 ? void 0 : ref10['0']) && /*#__PURE__*/ _jsx(Icon, {
                                type: "state-error",
                                className: "text-[13px] ml-[6px]"
                            })
                        ]
                    }),
                    source && (source === null || source === void 0 ? void 0 : (ref11 = source.OriginDetail) === null || ref11 === void 0 ? void 0 : ref11.Shard) && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "mr-[3px]",
                                children: gettext('Shard')
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                className: "mr-[40px]",
                                href: makeShardDetailLink(source.OriginDetail.Shard[0]),
                                text: toShard(source.OriginDetail.Shard[0])
                            })
                        ]
                    }),
                    targetAddress && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "mr-[5px]",
                                children: gettext('Target')
                            }),
                            /*#__PURE__*/ _jsx(AddressLink, {
                                className: "mr-[40px]",
                                address: targetAddress
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "mr-[5px]",
                        children: source === null || source === void 0 ? void 0 : source.Function
                    }),
                    (source === null || source === void 0 ? void 0 : source.Function) && /*#__PURE__*/ _jsx(Tooltip, {
                        placement: isScale ? 'bottom' : 'top',
                        trigger: "click",
                        overlay: renderContract,
                        children: /*#__PURE__*/ _jsx(Icon, {
                            type: "search-bold",
                            className: "cursor-pointer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: clss({
                    hidden: childStatus !== 'open'
                }, 'inline-flex items-center'),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "ex-tree-indent-unit"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "ex-tree-group",
                        children: ((source === null || source === void 0 ? void 0 : source.Children) || []).map(function(d) {
                            return(/*#__PURE__*/ _jsx(RelayItem, {
                                source: d,
                                onTrrigerChild: onTrrigerChild,
                                selected: selected,
                                isScale: isScale
                            }, d.Hash));
                        })
                    })
                ]
            })
        ]
    }));
};
export default observer(TransactionTree);
